/**
 * Used to classify the type of market segment.
 * tag: 2543
 * @readonly
 * @enum {number} (int)
 */
export enum MarketSegmentType {
  Pool = 1,
  Retail = 2,
  Wholesale = 3,
}
